import  { forwardRef, useContext } from 'react'
import ProductCard from './ProductCard'
import { ChooseTreatmentContext, Product } from '../FreeDosageLayoutV2'
import { getPrice } from '../../../../utils/translator';

interface Props {
  products: Product[],
  className?: string,
  productCardClassName?: string,
  flow?: string,
}

const ProductSelectionPanel = forwardRef<HTMLDivElement, Props>(({products, className, productCardClassName = "", flow }, ref) => {
  const chooseTreatmentContext = useContext(ChooseTreatmentContext);
  const locale = chooseTreatmentContext?.cart?.locale_id || 'de-DE';
  return (
    <div id='product-selection-container' className='flex flex-col'>
      <div id='product-selection' className={`flex flex-col items-center gap-3 pt-2 pb-6 ${className}`}>
        {
          products.map((product, index) => {
            const priceString = getPrice(product.visiblePrice, locale);         

            return (
              <ProductCard
                id={`product-card-container-${product.product_id}`}
                ref={(element: any) => {
                  if(chooseTreatmentContext?.productCardRefs?.current) {
                    chooseTreatmentContext.productCardRefs.current[index] = element;
                  }
                }}
                key={product.product_id.toString() + index + product.isSelected} 
                product={product}
                price={priceString}
                containerClassName={productCardClassName}
                flow={flow}
                labelData={product.labelData}
              />
            )
          })
        }
      </div>
    </div>
  )
});

export default ProductSelectionPanel